module.exports = __webpack_public_path__ + "media/เกินปุยมุ้ย.2f84a0f4.mp3";